// Use this entry point in shared UI; page data may use the full assets registry.
import { Images } from "./data/shared-images";
export { Images };
export { Icons } from "./data/shared-icons";
export { Videos } from "./data/videos";
export default Images;
